// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Dashboard_PegaDadosResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /dashboards/dashboard/pega_dados.
 *
 * Returns the entire main-dashboard "resumo" as a single object: faturamento /
 * despesas / resultado, orcamentos + compromissos counters, formas_pagamento +
 * categorias_servicos lists, marketing investment metrics, ticket medio,
 * repasses and fidelizados breakdowns.
 *
 * Each field is typed from the REAL response captured against the controller
 * (PROBE_CAPTURE_RESPONSE=1) and the underlying model SQL:
 *  - COUNT() aggregates surface as decimal strings (MySQL driver).
 *  - SUM()/AVG() aggregates surface as nullable strings (NULL on empty group),
 *    except where the SQL wraps them in COALESCE(...) (then non-null strings).
 *  - Controller-computed ratios (taxa_conversao, custoPorCliente, etc.) are
 *    floats; controller-computed differences/sums over the string aggregates
 *    are floats.
 *
 * The base AjaxResponse scaffolding field `data` (always null on this path)
 * is intentionally not carried — only `success`/`message`/`code` are kept,
 * matching the legacy wire shape.
 */
import type { Dashboard_PegaDadosCategoriaServicoRow } from './Dashboard_PegaDadosCategoriaServicoRow'
import type { Dashboard_PegaDadosCompromissosCanceladosRow } from './Dashboard_PegaDadosCompromissosCanceladosRow'
import type { Dashboard_PegaDadosConversaoClientesRow } from './Dashboard_PegaDadosConversaoClientesRow'
import type { Dashboard_PegaDadosFidelizadosRow } from './Dashboard_PegaDadosFidelizadosRow'
import type { Dashboard_PegaDadosFormaPagamentoRow } from './Dashboard_PegaDadosFormaPagamentoRow'
import type { Dashboard_PegaDadosIaoRow } from './Dashboard_PegaDadosIaoRow'
import type { Dashboard_PegaDadosOrcamentoOrigemRow } from './Dashboard_PegaDadosOrcamentoOrigemRow'
import type { Dashboard_PegaDadosRepassesRow } from './Dashboard_PegaDadosRepassesRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Dashboard_PegaDadosResponseDados {
success: boolean
message: string
code: number
valorInvestidoEmMarketing: string
coeficienteValorMarketingValorFaturado: number
custoPorCliente: number
resultado: number
formas_pagamento: Dashboard_PegaDadosFormaPagamentoRow[]
numero_orcamentos: string
numero_orcamentos_aprovados: string
taxa_conversao: number
numero_orcamentos_por_origem: Dashboard_PegaDadosOrcamentoOrigemRow[]
media_qtd_servicos_por_orcamento: string
numero_compromissos_realizados: string
numero_compromissos_total: string
previsto_na_agenda: number
diferenca_compromissos_orcamentos: number
ticket_medio: number
qtd_clientes: number
repasses: Dashboard_PegaDadosRepassesRow
categorias_servicos: Dashboard_PegaDadosCategoriaServicoRow[]
compromissos_cancelados: Dashboard_PegaDadosCompromissosCanceladosRow
clientes_fidelizados_orcamentos: Dashboard_PegaDadosFidelizadosRow
clientes_fidelizados_compromissos: Dashboard_PegaDadosFidelizadosRow
faturamento?: string
despesas?: string
recebido?: string
valor_total_orcamentos?: string
valor_total_compromissos?: string
valor_total_compromissos_futuros?: string
conversao_clientes?: Dashboard_PegaDadosConversaoClientesRow
iao?: Dashboard_PegaDadosIaoRow
}

export type Dashboard_PegaDadosResponse = ApiResponse<Dashboard_PegaDadosResponseDados>;

registerResponseContract('Dashboard_PegaDadosResponse', {
  success:                                { type: 'boolean', required: true },
  message:                                { type: 'string',  required: true },
  code:                                   { type: 'number',  required: true },
  valorInvestidoEmMarketing:              { type: 'string',  required: true },
  coeficienteValorMarketingValorFaturado: { type: 'number',  required: true },
  custoPorCliente:                        { type: 'number',  required: true },
  resultado:                              { type: 'number',  required: true },
  formas_pagamento: {
    type: 'array',
    required: true,
    items: {
      numero_compromissos:  { type: 'string',  required: false },
      forma_pagamento_id:   { type: 'number',  required: false },
      forma_pagamento_nome: { type: 'string',  required: false },
      total:                { type: 'string',  required: false },
    },
  },
  numero_orcamentos:                      { type: 'string',  required: true },
  numero_orcamentos_aprovados:            { type: 'string',  required: true },
  taxa_conversao:                         { type: 'number',  required: true },
  numero_orcamentos_por_origem: {
    type: 'array',
    required: true,
    items: {
      numero_orcamentos: { type: 'string',  required: false },
      media:             { type: 'string',  required: false },
      total:             { type: 'string',  required: false },
      origem:            { type: 'string',  required: false },
      origem_id:         { type: 'number',  required: false },
    },
  },
  media_qtd_servicos_por_orcamento:       { type: 'string',  required: true },
  numero_compromissos_realizados:         { type: 'string',  required: true },
  numero_compromissos_total:              { type: 'string',  required: true },
  previsto_na_agenda:                     { type: 'number',  required: true },
  diferenca_compromissos_orcamentos:      { type: 'number',  required: true },
  ticket_medio:                           { type: 'number',  required: true },
  qtd_clientes:                           { type: 'number',  required: true },
  repasses: {
    type: 'object',
    required: true,
    fields: {
      qtd_repasses: { type: 'number',  required: false },
      percentual:   { type: 'string',  required: false },
    },
  },
  categorias_servicos: {
    type: 'array',
    required: true,
    items: {
      numero_servicos: { type: 'string',  required: false },
      total:           { type: 'string',  required: false },
      categoria:       { type: 'string',  required: false },
      categoria_id:    { type: 'number',  required: false },
      percentual:      { type: 'number',  required: false },
    },
  },
  compromissos_cancelados: {
    type: 'object',
    required: true,
    fields: {
      numero_compromissos_cancelados: { type: 'string',  required: false },
      total:                          { type: 'string',  required: false },
    },
  },
  clientes_fidelizados_orcamentos: {
    type: 'object',
    required: true,
    fields: {
      qtd:         { type: 'number',  required: false },
      valor_total: { type: 'number',  required: false },
    },
  },
  clientes_fidelizados_compromissos: {
    type: 'object',
    required: true,
    fields: {
      qtd:         { type: 'number',  required: false },
      valor_total: { type: 'number',  required: false },
    },
  },
  faturamento:                            { type: 'string',  required: false },
  despesas:                               { type: 'string',  required: false },
  recebido:                               { type: 'string',  required: false },
  valor_total_orcamentos:                 { type: 'string',  required: false },
  valor_total_compromissos:               { type: 'string',  required: false },
  valor_total_compromissos_futuros:       { type: 'string',  required: false },
  conversao_clientes: {
    type: 'object',
    required: false,
    fields: {
      clientes_cadastrados: { type: 'number',  required: false },
      clientes_convertidos: { type: 'number',  required: false },
      percentual:           { type: 'string',  required: false },
    },
  },
  iao: {
    type: 'object',
    required: false,
    fields: {
      valor_operadores: { type: 'string',  required: false },
      faturamento:      { type: 'string',  required: false },
      percentual:       { type: 'string',  required: false },
    },
  },
})
